import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { StockResource } from '@df/catalog/stock/stock.resource';
import { Basket } from '@df/session/api/basket/basket';

export const basketItemsStockReloadResolver: ResolveFn<void> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const basket = inject(Basket);
    const promises = inject(StockResource)
        .getAll(basket.getProductIdsToLoad(), true)
        .map(i => i.load(1, { reload: true }));
    if (promises) {
        await Promise.all(promises);
    }
};
